import { createEnum } from "./utils";
import type { ReactNode } from "react";
import type { TableColumn, TableProps as DataTableProps } from "react-data-table-component";
import type { ColumnTooltipOption, CustomHeaderProps } from "@/types/common";

export type TableColumnWithIcon<T> = TableColumn<T> & { icon?: ReactNode; tooltip?: ColumnTooltipOption };

const PAGINATION = {
  DEFAULT_ROWS_PER_PAGE: 10,
  DEFAULT_PAGE_NUMBER: 1,
};
createEnum(PAGINATION);

export interface CustomTableProps {
  className?: string | undefined;
  // Renders CustomHeader as the table's own header bar — inside the same
  // bordered card as the grid, not as a separate component a page has to
  // assemble alongside Table. Omit to render a plain table with no toolbar.
  header?: CustomHeaderProps;
  paginationProps?: {
    isPagination: boolean;
    tableName?: string;
    pageSelected?: number;
    totalCount?: number;
    rowsPerPageValue?: number;
    setRowsPerPageValue?: (value: number) => void;
    setPageSelected?: (page: number) => void;
  };
  containerHeight?: string;
}

export type Props<T> = Omit<DataTableProps<T>, "columns"> &
  CustomTableProps & { columns?: TableColumnWithIcon<T>[] };

const VALIDATION_ERROR_MESSAGES = {
  EMAIL_FORMAT: "Invalid email format",
  PASSWORD_FORMAT: "Invalid password format",
  ONLY_NUMBERS: "Only numeric values allowed",
  INVALID_MOBILE: "Invalid mobile number",
  ZIP_CODE_FORMAT: "Invalid ZIP code",
  INCORRECT_PASSWORD: "Passwords do not match",
  RESET_PASSWORD_EMAIL: "Password reset email sent successfully",
  RESET_PASSWORD: "Password reset successfully",
};
createEnum(VALIDATION_ERROR_MESSAGES);

export { PAGINATION, VALIDATION_ERROR_MESSAGES };
